module.exports = require ('./index.js').singleton.get;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/translate/singletone.js